import React from "react";
import { Row, Col } from "react-bootstrap";
import style from "../ThemesLayout.module.css";

const ColorPallete = (props) => {
  const colorPalleteBoxStyle = props.colorPalletBoxStyle;
  return (
    <>
      {colorPalleteBoxStyle ? (
        <Row className={[style.colorPalleteBoxRow].join(" ")}>
          {colorPalleteBoxStyle &&
            colorPalleteBoxStyle.map((palleteDetails, index) => {
              return (
                <Col
                  className={style.colorPalletBox}
                  style={
                    palleteDetails !== null
                      ? {
                          backgroundColor: palleteDetails["backgroundColor"],
                          width: props.width,
                          height: props.height,
                        }
                      : null
                  }
                ></Col>
              );
            })}
        </Row>
      ) : (
        <></>
      )}
    </>
  );
};

export default ColorPallete;
